/*kiwi/build/tsu/pair*/
function _(require, module, exports) {
    /**
* A class which defines a generic pair object.
*/
    var Pair = function () {
        /**
    * Construct a new Pair object.
    *
    * @param first The first item of the pair.
    * @param second The second item of the pair.
    */
        function Pair(first, second) {
            this.first = first;
            this.second = second;
        }
        /**
    * Create a copy of the pair.
    */
        Pair.prototype.copy = function () {
            return new Pair(this.first, this.second);
        };
        return Pair;
    }();
    exports.Pair = Pair;
}